// A commissioner's overrides, from the screens (COMMISSIONER_OVERRIDES.md, J1):
// a lineup fixed for a week that is over, and points added or taken.
//
// ASKED AGAIN WHATEVER CAME BACK, as after any move: an override re-settles a
// week, so the lineup, the matchup, the scoreboard, the standings and the log
// all read again. Each resolves to what it did — and what could not be
// brought up to date after the scores moved — or to the sentence to show.

import { OverrideDone, type AdjustPointsRequest, type FixLineupRequest } from '@fsp/domain';
import { messageOf, send } from './api';
import { movesChanged } from './moves';

const NOT_SAVED = 'Could not reach the site. Nothing was changed.';

export type OverrideOutcome = { ok: true; problems: string[] } | { ok: false; message: string };

export async function fixLineup(
  leagueId: string,
  teamId: string,
  period: number,
  body: FixLineupRequest,
): Promise<OverrideOutcome> {
  const reply = await send(
    'PUT',
    `/leagues/${encodeURIComponent(leagueId)}/teams/${encodeURIComponent(teamId)}/lineup/fix?period=${period}`,
    body,
    OverrideDone,
  );
  setTimeout(() => movesChanged(leagueId), 0);
  return reply.status === 'ok'
    ? { ok: true, problems: reply.data.problems }
    : { ok: false, message: messageOf(reply, 'That fix did not save.', NOT_SAVED) };
}

export async function adjustPoints(
  leagueId: string,
  matchupId: string,
  body: AdjustPointsRequest,
): Promise<OverrideOutcome> {
  const reply = await send(
    'POST',
    `/leagues/${encodeURIComponent(leagueId)}/matchups/${encodeURIComponent(matchupId)}/adjustments`,
    body,
    OverrideDone,
  );
  setTimeout(() => movesChanged(leagueId), 0);
  return reply.status === 'ok'
    ? { ok: true, problems: reply.data.problems }
    : { ok: false, message: messageOf(reply, 'That did not save.', NOT_SAVED) };
}
